import { useQuery } from '@tanstack/react-query';
import { getVersion } from './connectorsApi';

export const useGetVersionHandler = (connectorKey, versionNumber) => {
  const query = useQuery({
    queryKey: ['connector-version', connectorKey, versionNumber],
    queryFn: () => getVersion(connectorKey, versionNumber),
    enabled: Boolean(connectorKey) && Boolean(versionNumber),
  });

  return {
    version: query.data,
    isLoading: query.isLoading,
    refetch: query.refetch,
  };
};
